import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Modal, Input } from 'hljd'
import Upload from '@common/Upload'
import store from '../store'
import style from '../../style.module.less'
const Item = Form.Item

@observer
export default class extends Component {
  render() {
    const {
      modal: { visible, weight, title, cover_path = '' }
    } = store
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    }

    return (
      <div>
        <Modal
          title="新建分类"
          width={800}
          visible={visible}
          onOk={store.isAdd}
          onCancel={store.cancelModal()}
          className={style.cate}
        >
          <div className={style.cateTip}>
            <img src="https://qnm.hunliji.com/o_1cjd4ksmofs0qdguq41vnc1f26c.jpg" />
            <img src="https://qnm.hunliji.com/o_1cjd4hf0i9hqjebcj0n231bgf7.jpg" />
            <p>
              创建分类可供用户高效浏览本店案例，分类标签的权重越大排序会越靠前。
            </p>
          </div>
          <div className={style.cateForm}>
            <Form>
              <Item label="分类名称" required {...formItemLayout}>
                <Input
                  value={title}
                  onChange={store.changeField('title')}
                  placeholder="如个性创意、西式婚礼、清新韩式等"
                />
              </Item>

              <Item label="分类权重" required {...formItemLayout}>
                <Input
                  value={weight}
                  onChange={store.changeField('weight')}
                  placeholder="请填写数字"
                />
              </Item>

              <Item label="封面设置" {...formItemLayout}>
                <p style={{ color: '#999' }}>封面图最优尺寸854*854px</p>
                <Upload
                  clipabled
                  target="_self"
                  aspect={400 / 400}
                  width={120}
                  height={120}
                  onOk={store.uploaded}
                  showDelete
                  onDelete={store.deleteImage}
                  link={cover_path ? cover_path : ''}
                  onCliped={store.clipPic}
                />
              </Item>
            </Form>
          </div>
        </Modal>
      </div>
    )
  }
}
